// @core/api/endpoints/userprofile/delete_userprofile.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/userprofile';

/**
 * Delete user profile
 * Permanently deletes a user profile and all associated data. This action is irreversible. Only the profile owner can delete their profile.
 */
export async function DeleteUserprofile(
  profile_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:profile_id`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
